module.exports = __webpack_public_path__ + "img/butterz_buzzingarden.6e5bc16.png";